import styled, { keyframes, css } from 'styled-components';
import { shade } from 'polished';

import { animated } from 'react-spring';
import { _ButtonProps } from 'styles/base';

interface ButtonProps extends _ButtonProps {
  $bgcolor: string;
  $animated: boolean | undefined;
  $delay: number;
}

const appear = keyframes`
from { opacity: 0} to { opacity:  1}
`;

export const Container = styled(animated.button)<ButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({$bgcolor}) => $bgcolor};
  color: #efefef;
  padding: 10px 20px;
  width: 250px;
  border: 2px solid transparent;
  border-radius: 5px;

  font-size: 16px;
  font-family: 'Roboto Slab', serif;
  font-weight: 700;

  transition: background-color 0.35s ease, color 0.35s ease;

  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;

  ${({$animated}) =>
    $animated &&
    css`
      opacity: 0;
      animation: ${appear} 1s ease forwards;
    `}

  ${({$delay}) =>
    $delay &&
    css`
      animation-delay: ${$delay}s;
    `}

  svg {
    width: 20px;
    height: 20px;
  }

  p {
    margin: 0 0 0 5px;
  }

  &:hover {
    background-color: ${({$bgcolor}) => shade(0.2, $bgcolor)};
    color: #fff;
  }
`;
